import React from 'react'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import * as Displays from '@morningtrain/react-displays'
import { SmallCardWithImage } from 'ui/cards'
import { Translation } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'
import Button from 'ui/buttons/Button'
import { FlexGrid } from 'ui/layouts'
import {SelectedDepartmentFilter} from "support/filters";
import {StaticFilter} from "@morningtrain/react-filters";

export default function Suppliers () {
  return (
    <Collection resourceName='inventory.supplier' operationName='index'>
      <StaticFilter name='without_ordered' value={1}/>
      <SelectedDepartmentFilter />
      <FlexGrid className='mt-4 mb-12' responsive={{ xl: 4, lg: 3, sm: 2 }}>
        <ForEachModel>
          <SmallCardWithImage
            forceColumn
            image={<Displays.Image name='image_url' />}
            title={<Displays.Text name='name' />}
            subtitle={<Displays.Text name='department_area' />}
          >
            <div className='mt-4'>
              <Link route='app.inventory.order.create' parameters={{ inventory_supplier: 'model:id' }}>
                <Button fullWidth>
                  <Translation name='inventory.overview.start_order' />
                </Button>
              </Link>
            </div>
          </SmallCardWithImage>
        </ForEachModel>
      </FlexGrid>
    </Collection>
  )
}
